<template>
  <v-container class='d-flex flex-column my-0 fill-height py-0' style="position:relative;">

    <div style="width:100%">
      <v-card class='mt-8 mb-2 rounded-lg' :loading="loading?'white':false">
        <v-card-title class='primary white--text pa-3'>
          <v-row class="">
            <v-col cols="6" class=""></v-col>
            <v-col cols="3" class="pl-0">
              <v-select :items="stagesFiltered" item-value="xid" item-text="title" outlined rounded dense dark hide-details placeholder="Job Stage" clearable v-model="stage" />
            </v-col>
            <v-col cols="3">
              <v-text-field
                placeholder='Filter...' append-icon='mdi-magnify'
                dark dense outlined rounded hide-details clearable
                class='mr-4'
                v-model='filterAuto'
              />
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </div>

    <div class="flex-grow-1" style="width:100%;position:relative;">

      <div style="position:absolute;width:100%;height:100%;" class="pa-0 d-flex">

        <div class="flex-grow-1 mx-2">
          <div class="fill-height d-flex flex-column" style="position:relative;">
            <div class="mt-4">
              <span class="text-subtitle-2 primary--text"><v-icon class="primary--text mr-4">mdi-playlist-star</v-icon>Top Priorities</span>
            </div>
            <div class="flex-grow-1" style="position:relative;">
              <PriorityList ref="priorityList" :jobs="jobs" :queue="priority_queue" @prioritiseIntent="prioritise" @rightClick="rightClickPriority" />
            </div>
          </div>
        </div>

        <div class="flex-grow-1 mx-2">
          <div class="fill-height d-flex flex-column" style="position:relative;">
            <div class="mt-4">
              <div class="text-subtitle-2 primary--text">
                <v-icon class="primary--text mr-4">mdi-auto-fix</v-icon>
                <span>Auto Prioritisation</span>
              </div>
            </div>
            <div class="flex-grow-1" style="position:relative;">
              <AutoList ref="autoList" :jobs="jobs" :queue='auto_queue' :stage="stage" :filter="filterAuto" />
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- LEFT CLICK POPUP (TASK MENU) -->
    <v-menu
      v-model="contextmenu.show_right"
      :position-x="contextmenu.x"
      :position-y="contextmenu.y"
      absolute offset-y
      ref="JobContextMenu"
    >
      <v-list dense>
        <v-list-item link @click="context_unprioritise"><v-icon color="primary" class="mr-2">mdi-arrow-right</v-icon>Unprioritise</v-list-item>
      </v-list>
    </v-menu>


  </v-container>
</template>

<style lang="scss" scoped>
.selected{
  background-color: lightblue;
}
</style>

<script>
import { mapGetters,  mapActions } from 'vuex';
import AutoList from './AutoList.vue';
import PriorityList from './PriorityList.vue';

export default {
  name: 'JobsPriorities',
  components: {
    AutoList, PriorityList
  },
  props: { },
  data(){ return {
    stage: null,
    loading: false,
    filterAuto: null,
    jobs: [],
    priority_queue: [],
    auto_queue: [],
    contextmenu: {
        show_right: false,
        context_element: null,
        job: null,
        x: null, y: null,
      },
  }},
  computed:{
    ...mapGetters("AUTH", ["USER"]),
    ...mapGetters("UI", ["JOB_STAGES", "CONTEXT_MENU"]),
    stagesFiltered(){
      return this.JOB_STAGES.filter(s=>s.activate_taskflows);
    }
  },
  watch: {
    $route: { handler(){ this.SET_TITLE("Job Priority"); }, immediate: true },
    CONTEXT_MENU(component){
      this.contextmenu.show_right = component === this.contextmenu.context_element;
    },
  },
  methods: {
    ...mapActions("UI", ["SET_TITLE", "NAVIGATE", "SET_CONTEXT_MENU"]),
    ...mapActions("API", ["API"]),

    refreshJobList(){
      this.loading = true;
      this.jobs = [];
      return this.API({ endpoint: `priorities/jobs` })
      .then(jobs => {
        this.jobs = jobs;
        this.loading = false;
      });
    },

    refreshAutoQueue(){
      this.loading = true;
      this.API({ endpoint: `priorities/jobs/not_prioritised` })
      .then(jobIds => {
        this.auto_queue = jobIds;
        this.loading = false;
      });
    },

    refreshPriorityQueue(){
      this.loading = true;
      this.API({ endpoint: `priorities/jobs/prioritised` })
      .then(jobIds => {
        this.priority_queue = jobIds;
        this.loading = false;
      });
    },

    prioritise({ job, position, siblingId }){
      this.loading = true;
      let data = { jobId: job.xid, position, siblingId };
      this.API({ method: 'POST', endpoint: `priorities/jobs/prioritise`, data })
      .then(priority_queue => {
        this.priority_queue = priority_queue;
        this.auto_queue = this.auto_queue.filter(j => !priority_queue.includes(j));
        this.loading = false;
      });
    },

    rightClickPriority({ job, e}){
      this.contextmenu = {...this.contextmenu,
        context_element: e.target,
        job,
        x: e.clientX, y: e.clientY
      };
      this.SET_CONTEXT_MENU(e.target);
    },

    context_unprioritise(){
      this.prioritise({ job: this.contextmenu.job, position: 'remove', siblingId: null });
    }

  },
  mounted(){
    this.refreshJobList()
    .then(this.refreshPriorityQueue)
    .then(this.refreshAutoQueue);
  }
}
</script>
